/** 数据中心 · 配料机数据 · 校准/满管（patch 369；parent 1776875108514795520） */
export const TEA_XT_SERIES_CALIB_FULLPIPE_MENU_IDS = {
  calibrationData: 991130,
  fullPipeData: 991131,
  parent: 1776875108514795520,
  calibrationEnName: 'calibrationData',
  fullPipeEnName: 'fullPipeData',
  parentEnName: 'XTSeriesData'
}



// WEBPACK FOOTER //
// ./src/constants/teaXtSeriesCalibFullpipe.js